import { Outlet } from "react-router-dom"
import Header from "./Header"
import Footer from "./Footer"
export default function MainLayout () {

  return (
    <>
    <Header />
    <div className="mt-16 px-16 min-h-screen">
    <Outlet />
    </div>
    <Footer />
    </>
  )
}
